// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1_iaW","cls2":"ConfirmationModal-cls2_wIS ConfirmationModal-cls1_iaW"};